module.exports = __webpack_public_path__ + "static/media/logo__0000_Alibaba.a40e1532.png";